import React, { Component } from 'react';
import { Grid, List, Hidden, Slide } from '@material-ui/core';

import withWidth, { isWidthUp } from '@material-ui/core/withWidth';

import ContactItem from './ContactItem';
import { ContactDetail } from './ContactDetail';
import Pane from './containers/Pane';
import { FilterTabs } from './containers/FilterTabs';
import { Fragment } from 'react';
import DetailsCard from './containers/DetailsCard';
import DetailsCardModal from './containers/DetailsCardModal';
import { LoadingProgress } from './containers/LoadingProgress';

class Contacts extends Component {

  state = {
    open: false,
    enter: false,
    selectedFilter: 0,
  }

  componentDidMount() {
    this.props.onRefreshData();
  }

  componentWillUnmount() {
    this.props.onClose();
  }

  handleMail = (mail) => {
    window.open(`mailto:${mail}`);
  }

  handleCall = (phone) => {
    window.open(`tel:${phone}`);
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleOnEnter = () => {
    this.setState({enter: true});
  }
  handleOffEnter = () => {
    this.setState({enter: false});
  }

  handleClose = () => {
    const transitionDelay = isWidthUp('md', this.props.width) ? 300 : 0;
    this.handleOffEnter();
    this.setState({ open: false });
    setTimeout(() => {
      this.props.onClose();
    },transitionDelay);
  };

  handleSelect = (id) => {
    this.props.onSelect(id);
    this.handleOnEnter();
    if (!isWidthUp('md', this.props.width)) {
      this.handleOpen();
    }
  }

  getContactsByFilter() {
    return Object.entries(
      this.props.contacts.reduce((contacts, contact) => {
        const filtersArray = contact.filters.split('|');
        for (let i = 0; i < filtersArray.length; i++) {
          contacts[filtersArray[i]] = contacts[filtersArray[i]]
          ? [...contacts[filtersArray[i]], contact]           
          : [contact]
        }
        return contacts;
      }, {})
    );
  }

  handleFilterSelected = selectedFilter => {
    this.setState({
      selectedFilter
    });
  };

  render() {
    const {
      contacts,
      filters,
      contactItem: {
        id,
        person,
        name,
        phone,
        extension,
        mail,
      },
      translations,
      appLanguage,
    } = this.props;
    const { enter, selectedFilter } = this.state;
    const contactItems = selectedFilter ? this.getContactsByFilter().map(([filter, contacts]) => {
      return selectedFilter === filter
      ? contacts.map(contact => {
        return(
          <ContactItem
            key={contact.id}
            contact={contact}
            appLanguage={appLanguage}
            onSelect={() => this.handleSelect(contact.id)}
          />
        )
      })
      : null
    })
    : contacts.map(contact => {
      return(
        <ContactItem
          key={contact.id}
          contact={contact}
          appLanguage={appLanguage}
          onSelect={() => this.handleSelect(contact.id)}
        />
      )
    });
    return (
      <Fragment>
        <Grid container spacing={24} justify='center' >
          <Grid item xs zeroMinWidth style={{maxWidth: 800}}>
            <Pane
              header={translations.t_TITLE_CONTACTS[appLanguage]}
              filterTabs={ filters.length > 0 ?
                <FilterTabs
                  filters={filters}
                  selectedFilter={selectedFilter}
                  onFilterSelect={this.handleFilterSelected}
                />
                : null
              }
            >
              <LoadingProgress data={contacts}>
                <List>
                  {contactItems}
                </List>
              </LoadingProgress>
            </Pane>
          </Grid>
          
          { id ? 
            <Fragment>
              <Hidden smDown>
                <Grid item xs lg={5}>
                  <Slide direction="left" in={enter} mountOnEnter unmountOnExit>
                    <DetailsCard
                      title={person}
                      subheader={name}
                      appLanguage={appLanguage}
                      onClose={this.handleClose}
                    >
                      <ContactDetail
                        phone={phone}
                        extension={extension}
                        mail={mail}
                        handleCall={() => this.handleCall(phone)}
                        handleMail={() => this.handleMail(mail)}
                      />
                    </DetailsCard>
                  </Slide>
                </Grid>
              </Hidden>
              <DetailsCardModal
                ariaLabelledby="contact-modal-title"
                ariaDescribedby="contact-modal-description"
                appLanguage={appLanguage}
                open={this.state.open}
                onClose={this.handleClose}
                title={person} subheader={name}
              >
                <ContactDetail
                  phone={phone}
                  extension={extension}
                  mail={mail}
                  handleCall={() => this.handleCall(phone)}
                  handleMail={() => this.handleMail(mail)}
                />
              </DetailsCardModal>
            </Fragment>
          : null
          }
        </Grid>
      </Fragment>
    )
  } 
}

export default withWidth()(Contacts);


// WEBPACK FOOTER //
// ./src/components/Contacts.js